(function Index($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/Reservations/view/', function onload()
		{
			$('.request-booking').click(function _getBooking(e) {
			   var $modal         = $(".modal"),
				   reservation_id = $(this).data('id');
				e.preventDefault();

				$('#fetcher').removeClass('d-none');

				HE.Ajax.get('/Reservations/details/' + reservation_id).then(function processed(response) {
					$('.modal-dialog').addClass('mw-100 w-75');

					$modal.find('.modal-title').text('Details');
					$modal.find('.modal-body').html(response);
					$modal.modal('show');

					$('#fetcher').addClass('d-none');
				});
			});

			$('.add-note').click(function _addNote() {
				var reservation_id = $(this).data('reservation-id'),
					note = $('#note').val(),
					data = {
						note          : note,
						reservation_id: reservation_id
					};

				HE.Ajax.post('/Reservations/addNote/', data).then(function _success(response) {
					 document.location = HE.base_uri + '/Reservations/view/' + reservation_id;
				});
			});

			$('.update-status').click(function _updateStatus() {
				var reservation_id = $(this).data('reservation-id'),
					status         = $('#commssion_status').val(),
					data = {
						status        : status,
						reservation_id: reservation_id,
						note          : $('#commission-note').val(),
						amount        : $('#commission-amount').val()
					};

				if (status === 'adjusted' && $('#commission-amount').val().length <= 0) {
					HE.StatusMessage('error', "For the adjusted commission status, the amount is required.");
				} else {
					HE.Ajax.post('/Reservations/updateStatus/', data).then(function _success(response) {
						document.location = HE.base_uri + '/Reservations/view/' + reservation_id + '/tab:tracking';
					});
				}
			});

			$('.update-refund-status').click(function _updateStatus() {
				var reservation_id = $(this).data('reservation-id'),
					status         = $('#refund_status').val(),
					data = {
						status        : status,
						reservation_id: reservation_id,
						note          : $('#refund-note').val(),
						amount        : $('#refund-amount').val()
					};

				if (status === 'manual_partial_refund_required' && $('#refund-amount').val().length <= 0) {
					HE.StatusMessage('error', "For a partial refund, the amount is required.");
				} else {
					HE.Ajax.post('/Reservations/updateRefundStatus/', data).then(function _success(response) {
						document.location = HE.base_uri + '/Reservations/view/' + reservation_id + '/tab:tracking';
					});
				}
			});

		});

		$('[data-bs-toggle="collapse"]').click(function _toggleChevron() {
			var $icon = $(this).find('i');
			if ($icon.hasClass('fa-chevron-down')) {
				$icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
			} else {
				$icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
			}
		});
	});
}(jQuery, window.HE || {}));